<template>
  <v-app-bar
    flat
    scroll-behavior="hide"
    class="px-4 pt-2 glass-header"
  >
    <v-app-bar-title class="font-weight-black text-h5 text-primary">
      <v-icon icon="mdi-calendar-clock" class="mr-2"></v-icon>
      디데이 D-Day
    </v-app-bar-title>

    <v-spacer></v-spacer>

    <v-btn to="/" variant="text" rounded="xl" class="font-weight-bold">날짜 차이</v-btn>
    <v-btn to="/calculate" variant="text" rounded="xl" class="font-weight-bold">날짜 계산</v-btn>
    <v-btn to="/countdown" variant="text" rounded="xl" class="font-weight-bold">카운트다운</v-btn>

    <v-btn icon @click="toggleTheme" class="ml-2">
      <v-icon>{{ isDark ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script setup>
import { useTheme } from 'vuetify'
import { computed } from 'vue'

const theme = useTheme()
const isDark = computed(() => theme.global.current.value.dark)

function toggleTheme() {
  theme.global.name.value = isDark.value ? 'light' : 'dark'
}
</script>

<style scoped>
.glass-header {
  background-color: rgba(var(--v-theme-surface), 0.8) !important;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.05);
}
</style>